import { WALLET_ADMIN_TYPES } from "store/types";

const initialState = {
  wallets: [],
  count: 0,
  activeCount: 0,
  frozenCount: 0,
  totalFloat: 0,
  loading: false,
  wallet: null,
  transactions: [],
};

const walletAdminReducers = (state = initialState, action) => {
  switch (action.type) {
    case WALLET_ADMIN_TYPES.SET_LOADING:
      return { ...state, loading: action.payload };
    case WALLET_ADMIN_TYPES.FETCH_WALLETS_SUCCESS:
      return {
        ...state,
        wallets: action.payload.data,
        count: action.payload.count,
        activeCount: action.payload.activeCount,
        frozenCount: action.payload.frozenCount,
        totalFloat: action.payload.totalFloat,
      };
    case WALLET_ADMIN_TYPES.FETCH_WALLET_SUCCESS:
      return { ...state, wallet: action.payload };
    case WALLET_ADMIN_TYPES.FETCH_WALLET_TXNS:
      return { ...state, transactions: action.payload };
    default:
      return state;
  }
};

export default walletAdminReducers;
